import React from 'react';
import { Header3Text } from 'ui-toolkit';
import { StyledFeeSection, StyledFeeSectionHeader } from './FeeSections.Styled';
import { FeeSectionTable } from './table/FeeSectionTable';
import { IFeeSection } from './organizeFees';

interface ICashToSectionProps {
  feeSections: IFeeSection[];
}

export const CashToSection: React.FC<ICashToSectionProps> = ({ feeSections }) => {
  const sectionCashToClose = feeSections.find((t) => t.sectionDefinition.sectionDescription === 'Cash To Close');

  return (
    <>
      {sectionCashToClose && (
        <StyledFeeSection>
          <StyledFeeSectionHeader>
            <Header3Text>Cash To Close</Header3Text>
          </StyledFeeSectionHeader>
          <FeeSectionTable feeSection={sectionCashToClose} layout={'Two Column'} />
        </StyledFeeSection>
      )}
    </>
  );
};
